export class Search {
	static readonly type = '[fireInsuranceBrokersSearch] search';
	constructor(
		public payload: {
			searchTerm: string;
			brokerageId?: string;
		},
	) {}
}
